<template>
  <Transition name="update-banner">
    <div
      v-if="visible"
      class="fixed bottom-safe-4 right-4 z-50 w-80 max-w-[calc(100vw-2rem)] rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 space-y-3"
      role="status"
      aria-live="polite">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ headline }}</p>
          <p v-if="status === 'downloading'" class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ progress }}%</p>
          <p v-else-if="status === 'error'" class="text-xs text-red-600 dark:text-red-400 mt-0.5 break-words">
            {{ errorMessage }}
          </p>
        </div>
        <button
          v-if="status === 'downloaded'"
          @click="quitAndInstall"
          class="shrink-0 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-xs font-medium rounded-lg transition-colors">
          {{ t('settings.settingsUpdates.restartInstall') }}
        </button>
      </div>

      <div v-if="status === 'downloading'" class="h-1.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
        <div class="h-full bg-blue-500 transition-all duration-300" :style="{ width: `${progress}%` }"></div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useElectronUpdates } from '../composables/useElectronUpdates';

const { t } = useI18n();
const { isElectron, status, progress, errorMessage, quitAndInstall } = useElectronUpdates();

const visible = computed(
  () => isElectron && (status.value === 'downloading' || status.value === 'downloaded' || status.value === 'error'),
);

const headline = computed(() => {
  switch (status.value) {
    case 'downloading':
      return t('settings.settingsUpdates.downloadingUpdate');
    case 'downloaded':
      return t('settings.settingsUpdates.updateReady');
    case 'error':
      return t('settings.settingsUpdates.updateFailed');
    default:
      return '';
  }
});
</script>

<style scoped>
.update-banner-enter-active,
.update-banner-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}
.update-banner-enter-from,
.update-banner-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
